// Faz BO (2026-05-10) — Sayfa iskeleti (Sidebar + Topbar + Outlet)
// Eski Layout.js'in yerine geçer. Faz BP'de Topbar redesign edilecek.
import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import Sidebar, { SIDEBAR_FULL_WIDTH, SIDEBAR_MINI_WIDTH } from "./Sidebar";
import Topbar from "./Topbar";
import QuickSearch from "../QuickSearch";

const COLLAPSED_KEY = "miksan-sidebar-collapsed";

export default function AppShell() {
  const [collapsed, setCollapsed] = useState(() => {
    try { return window.localStorage.getItem(COLLAPSED_KEY) === "1"; } catch { return false; }
  });
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    try { window.localStorage.setItem(COLLAPSED_KEY, collapsed ? "1" : "0"); } catch { /* ignore */ }
  }, [collapsed]);

  const sidebarWidth = collapsed ? SIDEBAR_MINI_WIDTH : SIDEBAR_FULL_WIDTH;

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "background.default" }}>
      <QuickSearch />

      <Sidebar
        isMini={collapsed}
        onCollapseToggle={() => setCollapsed(c => !c)}
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          width: { xs: "100%", md: `calc(100% - ${sidebarWidth}px)` },
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Topbar onMobileMenuClick={() => setMobileOpen(true)} />
        <Box sx={{ flex: 1, p: { xs: 2, md: 3 } }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
